<template>
  <span class="svg-ico-paper-plane">
    <svg :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10.9708 17.4856C12.2908 21.4556 13.9608 22.2856 15.1408 22.2856C16.3208 22.2856 17.9908 21.4556 19.3208 17.4756L22.1508 8.98559C22.8608 6.86559 22.6508 5.08559 21.5608 4.00559C20.4708 2.92559 18.7008 2.71559 16.5808 3.42559L8.09078 6.25559C4.13078 7.58559 3.30078 9.26559 3.30078 10.4356C3.30078 11.6156 4.13078 13.2856 8.09078 14.6056L10.2508 15.3256L10.9708 17.4856ZM4.79078 10.4356C4.79078 9.71559 5.78078 8.61559 8.56078 7.68559L17.0508 4.84559C18.5808 4.33559 19.8408 4.41559 20.4908 5.06559C21.1408 5.71559 21.2308 6.97559 20.7208 8.51559L17.8908 17.0056C16.9608 19.7856 15.8608 20.7756 15.1408 20.7756C14.4208 20.7756 13.3108 19.7856 12.3908 17.0056L11.6407 14.7554L15.1407 11.2456C15.4307 10.9556 15.4307 10.4756 15.1407 10.1856C14.8507 9.89558 14.3707 9.89558 14.0807 10.1856L10.5007 13.7756C10.4891 13.7871 10.478 13.799 10.4674 13.8111L8.56078 13.1756C5.78078 12.2556 4.79078 11.1556 4.79078 10.4356Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default: '#E0E3E6' },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean }
  }
}
</script>
